import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckIcon, DownloadIcon, XIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { PublicVisibilityControls } from '../../components/PublicVisibilityControls';
import { SettingsGroup, SettingsRow, SettingsToggleRow } from '../../components/SettingsList';
import { Card, SectionTitle } from '../../components/ui/Card';
import { consentHistory, privacyPrefs } from '../../data/settings';
import { useLocale } from '../../contexts/LocaleContext';
import { useSettings } from '../../contexts/SettingsContext';
export function PrivacySettings() {
  const {
    t,
    tl
  } = useLocale();
  const navigate = useNavigate();
  const settings = useSettings();
  const account = privacyPrefs.filter(pref => pref.scope === 'account');
  return <div className="px-2 pb-2" data-id="element-3762" data-mp="3r7pimv5671cg">
      <PageHeader title={t('settings.privacy')} subtitle={t('privacy.subtitle')} showBack data-id="element-3763" data-mp="3r8hdu4uuux27" />

      <SectionTitle data-id="element-3764" data-mp="lly02pxc2qt7">{t('privacy.visibility')}</SectionTitle>
      <SettingsGroup data-id="element-3765" data-mp="lniw6jzaqht6">
        {account.map(pref => <SettingsToggleRow key={pref.id} label={tl(pref.label)} hint={tl(pref.hint)} checked={settings.privacy[pref.id]} onChange={() => settings.togglePrivacy(pref.id)} data-id="element-3766" data-mp="gmboekx5limi" />)}
      </SettingsGroup>

      <div className="mt-3" data-id="element-3767" data-mp="7oj3n18nxirq">
        <PublicVisibilityControls data-id="element-3768" data-mp="14cp5xhi43z2u" />
      </div>

      <section className="mt-3" data-id="element-3769" data-mp="14bnxlkshdqot">
        <SectionTitle data-id="element-3770" data-mp="zdmdcwjbjlbr">{t('privacy.dataUse')}</SectionTitle>
        <Card className="p-2" data-id="element-3771" data-mp="ze4fg9snwtrl">
          <ul className="space-y-1" data-id="element-3772" data-mp="ummehlqn2t6m">
            {['privacy.use1', 'privacy.use2', 'privacy.use3'].map(key => <li key={key} className="flex items-start gap-2 text-[12.5px] leading-snug text-deep" data-id="element-3773" data-mp="qlkg174jql5p">
                <span className="mt-[6px] h-[5px] w-[5px] shrink-0 rounded-pill bg-gold" aria-hidden="true" data-id="element-3774" data-mp="1n489pqjynh5x" />
                {t(key)}
              </li>)}
          </ul>
        </Card>
      </section>

      <section className="mt-3" data-id="element-3775" data-mp="3hjf4vyukcbgx">
        <SectionTitle data-id="element-3776" data-mp="3hidnzdqv8ura">{t('privacy.consent')}</SectionTitle>
        <ul className="rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3777" data-mp="32v0zph9ocax7">
          {consentHistory.map(entry => <li key={entry.id} className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-3778" data-mp="37rrg65pe58j5">
              <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-pill ${entry.granted ? 'bg-gold text-deep' : 'bg-sand-deep text-muted'}`} data-id="element-3779" data-mp="2yse1mymettrk">
                {entry.granted ? <CheckIcon size={14} strokeWidth={3} data-id="element-3780" data-mp="2owkj8ym0f61v" /> : <XIcon size={14} data-id="element-3781" data-mp="i4jqtxv0uzgc" />}
              </span>
              <span className="min-w-0 flex-1" data-id="element-3782" data-mp="n3d7u09ip8l9">
                <span className="block text-[13px] font-medium text-deep" data-id="element-3783" data-mp="n10opjs0ws6m">
                  {tl(entry.label)}
                </span>
                <span className="mt-[2px] block text-[11px] text-muted" data-id="element-3784" data-mp="22mku4vp6ryq2">
                  {tl(entry.when)}
                </span>
              </span>
            </li>)}
        </ul>
      </section>

      <div className="mt-3" data-id="element-3785" data-mp="2cjqnkal9w1tg">
        <SettingsGroup data-id="element-3786" data-mp="2cjgvmhgo3kl4">
          <SettingsRow label={t('account.export')} hint={t('account.exportHint')} icon={<DownloadIcon size={17} data-id="element-3788" data-mp="2qdhst6rz0zjd" />} onClick={() => navigate('/config/dados')} data-id="element-3787" data-mp="2ci5rggjb8ath" />
        </SettingsGroup>
      </div>

    </div>;
}